import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PAYMENT_FAILED_EVENT, PAYMENT_INITIATED_EVENT } from '../../../api/api';
import { paymentRequests } from '../../../api/payment/api';
import cacheQueryKeys from '../../../resources/queryCacheKeys';

import { useServerSideEvents } from './useServerSideEvents';

export const usePayByCard = () => {
  const queryClient = useQueryClient();
  const { mutate: sendServerEvent } = useServerSideEvents();

  const mutation = useMutation({
    mutationFn: paymentRequests.payByCard,
    onSuccess: () => {
      sendServerEvent({
        eventName: PAYMENT_INITIATED_EVENT,
      });
      queryClient.setQueryData([cacheQueryKeys.PaymentStatus], { status: 'initiated' });
    },
    onError: () => {
      sendServerEvent({
        eventName: PAYMENT_FAILED_EVENT,
      });
      queryClient.setQueryData([cacheQueryKeys.PaymentStatus], { status: 'failed' });
    },
  });

  return mutation;
};
